import React from 'react'
import gsap from 'gsap'
import { useState } from 'react'
import './lightbox.css'

import exitIcon from "../assets/exit.svg"
import lineBreak from "../assets/lineBreak.svg"

import AboutLightbox from './content/AboutLightbox'
import InjectablesLightbox from './content/InjectablesLightbox'
import LaserLightbox from './content/LaserLightbox'
import AestheticsLightbox from './content/AestheticsLightbox'

const Lightbox = (props) => {

    const title = props.title
    const lightboxContent = props.lightboxContent
    const [ preventBackgroundExit, setPreventBackgroundExit ] = useState(false)

    const body = document.querySelector('.body')
    body.style = 'overflow-y:hidden;'

    const exit = () =>
    {
        body.style = ''
        props.closeLightbox()
    }

    const backgroundExit = () =>
    {
      if (!preventBackgroundExit)
      {
        body.style = ''
        props.closeLightbox()
      }
    }

    const preventExit = () =>
    {
      setPreventBackgroundExit(true)
    }

    const allowExit = () =>
    {
      setPreventBackgroundExit(false)
    }

    return (
    <div className="section__expandedbox active" onClick={backgroundExit}>
      <div className="section__expandedcontainer">
        <div className="section__expandedexit">
          <img src={exitIcon} alt="" onClick={exit} />
        </div>
        <div className='lightbox__content' onMouseOver={preventExit} onMouseLeave={allowExit}>
          <h1 className="section__expandedtitle">{ title }</h1>
          <span className='lightbox__linebreak'><img src={lineBreak} alt="" /></span>
          { lightboxContent === 0 ? <AboutLightbox /> : null }
          { lightboxContent === 1 ? <InjectablesLightbox /> : null }
          { lightboxContent === 2 ? <LaserLightbox /> : null }
          { lightboxContent === 3 ? <AestheticsLightbox /> : null }
        </div>
      </div>
    </div>
  )
}

export default Lightbox
